import goldZj from '../images/gold-zj.png';
import goldZy from '../images/gold-zy.png';

export default function GoldCoin({size, ...others}: any) {
    const img = localStorage.getItem('theme') === 'zhongji' ? goldZj : goldZy;
    return <img src={img} alt="coin" width={size} height={size} {...others}/>
}